export function buildTocMenu(contentElement) {
  const menu = document.createElement('ul')
  menu.classList.add('hidden')

  contentElement.querySelectorAll('h2').forEach((heading, index) => {
    const sectionId = `section${index + 1}`
    const anchorTarget = document.createElement('span')
    anchorTarget.id = sectionId
    heading.prepend(anchorTarget)

    const listItem = document.createElement('li')
    const link = document.createElement('a')
    link.href = `#${sectionId}`
    link.dataset.smoothAnchor = ''
    link.textContent = `${index + 1}. ${heading.textContent}`
    listItem.append(link)
    menu.append(listItem)
  })

  return menu
}

export function initArticleToc() {
  const tocSlot = document.getElementById('hapisumu-header-toc-slot')
  const generatedToc = document.getElementById('toc_container')
  if (tocSlot instanceof HTMLElement) {
    if (generatedToc instanceof HTMLElement) tocSlot.append(generatedToc)
  }

  const toc = document.getElementById('hapisumu-toc')
  const tocTitle = document.getElementById('hapisumu-toc__title')
  const content = document.querySelector('.main-content')
  if (!(toc instanceof HTMLElement) || !(tocTitle instanceof HTMLElement) || !(content instanceof HTMLElement)) return
  if (toc.dataset.articleTocInitialized === 'true') return

  const menu = buildTocMenu(content)
  if (menu.children.length === 0) {
    toc.hidden = true
    return
  }

  toc.append(menu)

  const toggleLink = document.createElement('a')
  toggleLink.href = '#'
  toggleLink.classList.add('toggle-toc')
  toggleLink.textContent = '（目次を表示する）'
  tocTitle.append(toggleLink)

  toggleLink.addEventListener('click', (event) => {
    event.preventDefault()
    menu.classList.toggle('visible')
    if (menu.classList.contains('visible')) {
      menu.classList.remove('hidden')
      toggleLink.textContent = '（目次を閉じる）'
      return
    }

    menu.classList.add('hidden')
    toggleLink.textContent = '（目次を表示する）'
  })

  toc.dataset.articleTocInitialized = 'true'
}
